import React, { useEffect } from 'react'
import {
  Redirect, withRouter,
} from 'react-router-dom'
import LineInformation from './InformationLine'
import { compose } from 'recompose'
import { useMutation } from '@apollo/client'
import queryString from 'query-string'
// import '../styles/legacy/style.scss'
import CircularProgress from '@material-ui/core/CircularProgress'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { FIRST_LOGIN } from '../queriesAndMutations'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  circularProgressWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
}))

const FirstLogin = ({ history }) => {
  const classes = useStyles()
  const { t } = useTranslation();
  const [firstLogin, { data, loading, error }] = useMutation(FIRST_LOGIN)

  const query = queryString.parse(history.location.search)
  const firstAuthToken = (query || {}).first_auth_token

  useEffect(() => {
    firstLogin({ variables: { first_auth_token: firstAuthToken } }).catch(() => {})
  }, [firstLogin, firstAuthToken])

  if (data) {
    localStorage.setItem('jwt', data.firstLogin.accessToken)
    return <Redirect to="/application" />
  }

  if (error) {
    return (
      <div className="entry__fieldset">
        <LineInformation
          informationColor="box__information-red"
          text={t('Login error')}
          icon="close"
        />
      </div>
    )
  }

  return (
    <div className="entry__fieldset">
      { loading && (
      <>
        <LineInformation
          informationColor="box__information-green"
          text={t('Login in progress')}
          icon="check"
        />
      </>
      )}
      <div className={classes.circularProgressWrapper}><CircularProgress /></div>
    </div>
  )
}

export default compose(
  withRouter
)(FirstLogin)
